/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';

import ArrivedGift from '../assets/svg/ArrivedGift';

const StatusTracking = (props) => {
    const {
        status, ROSSStatus, ROSSOrderPendingCancel, isROSSUIEnabled, IsPendingCancelEnabled,
    } = props;
    let orderStatus = 1;

    const ROSSPendingCancelImg = <img className="ROSS-status-img" alt="pending cancel" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt8406336d422ecfc8/611fdd93e8898d66a7c9552b/Cancel_Pending_Bar.svg" />;
    const ROSSPendingCancel = ROSSOrderPendingCancel && ROSSStatus !== 'C';

    const renderROSSStatus = () => {
        switch (ROSSStatus) {
            case 'CANCELLED':
                return <img className="ROSS-status-img" alt="canceled" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt106cee8300a62b2e/5f9715e5f9cf41781dad39c8/cancelled.svg" />;
            case 'CONFIRMED':
                return <img className="ROSS-status-img" alt="confirmed" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt99d25268b9941e32/5f9715bf1f9166620ed85bce/confirmed.svg" />;
            case 'IN TRANSIT':
                return <img className="ROSS-status-img" alt="in transit" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt3bba57afd41534f4/5f9715bf209f0756c89d3d1b/in-transit.svg" />;
            case 'DELIVERED':
                return <img className="ROSS-status-img" alt="delivered" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/bltb2c40ac227b0cabd/5f9715bacb9eba781f084dff/delivered.svg" />;
            default:
                return <img className="ROSS-status-img" alt="confirmed" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt99d25268b9941e32/5f9715bf1f9166620ed85bce/confirmed.svg" />;
        }
    };

    switch (status) {
        case 'I':
            orderStatus = 2;
            break;
        case 'D':
        case 'U':
            orderStatus = 3;
            break;
        case 'C':
            orderStatus = 0;
            break;
        default:
            orderStatus = 1;
    }

    let steps = ['Confirmed', 'In Transit', 'Delivered'];
    if (orderStatus === 0) {
        steps = ['', 'Cancelled', ''];
    }
    let stepClasses = '';
    steps.map((s, i) => {
        if (i < orderStatus) {
            stepClasses += ['step-', i + 1, ' '].join('');
        }
    });
    if (orderStatus === 0) {
        stepClasses = 'step-0';
    }

    return ROSSStatus && isROSSUIEnabled ? (
        <div className="orderDetail">
            {IsPendingCancelEnabled && ROSSPendingCancel ? ROSSPendingCancelImg : renderROSSStatus()}
        </div>
    ) : (
        <>
            <div className={`statusTrackingBar margin-top ${stepClasses}`}>
                {steps.map((step, i) => (
                    <div key={['_', i].join('')} className="step">
                        <div className="h2">{step}</div>
                    </div>
                ))}
                {orderStatus === 3 && (
                    <div className="arrivedGift">
                        <ArrivedGift />
                    </div>
                )}
            </div>
        </>
    );
};

StatusTracking.defaultProps = {
    status: '',
    ROSSStatus: '',
    ROSSOrderPendingCancel: false,
    IsPendingCancelEnabled: false,
};

StatusTracking.propTypes = {
    status: PropTypes.string,
    ROSSStatus: PropTypes.string,
    isROSSUIEnabled: PropTypes.bool.isRequired,
    ROSSOrderPendingCancel: PropTypes.bool,
    IsPendingCancelEnabled: PropTypes.bool,
};

export default StatusTracking;
